import React from "react";
import { useSpring, animated } from 'react-spring';
import './button.scss';

const Button = ({style = {}, type, className = '', children, onClick = () => {}, submit}) => {
    const [props, api] = useSpring(() => ({
        scale: 1,
        boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 1)',
    }))

    const setType = () => {
        if (type) {
            return `button-main--${type}`
        }

        return ''
    }

    return <animated.div
        style={{...props, ...style}}
        className={`button-main ${className} ${setType()}`}
        onMouseEnter={() => type !== 'text' && api.start({
            scale: 1.01,
            boxShadow: '0 10px 30px -5px rgba(0, 0, 0, 0.5)',
        })}
        onMouseLeave={() => type !== 'text' && api.start({
            scale: 1,
            boxShadow: '0 0 0 0 rgba(0, 0, 0, 1)',
        })}
        onClick={onClick}
    >
        {
            children
        }
    </animated.div>
}

export default Button;